@if (flyout && node?.children.length > 1) {
  <div
    class="back is-open"
    (click)="back()"
    >
    <h5>
      <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
      {{ 'common.back' | cxTranslate }}
    </h5>
  </div>
}

@for (child of node?.children; track child; let index = $index) {
  <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0, count: node?.children.length, index: index }">
  </ng-container>
}

<!-- we generate links in a recursive manner -->
<ng-template #nav let-node="node" let-depth="depth" let-count="count" let-index="index">
  <nav
    (click)="toggleOpen($event)"
    (mouseenter)="onMouseEnter($event)"
    (keydown.space)="toggleOpen($event)"
    (keydown.esc)="back()"
    >
    @if (
      node.url && (!node.children || node.children?.length === 0)) {
      <cx-generic-link
        [url]="node.url"
        [target]="node.target"
        [style]="node.styleAttributes"
        [class]="node.styleClasses"
        >
        {{ node.title }}
        @if (flyout && node.children?.length > 0) {
          <cx-icon
            [type]="iconType.CARET_DOWN"
          ></cx-icon>
        }
      </cx-generic-link>
    } @else {
      @if (!node.isParagraphComponent) {
        <h5
          [attr.aria-label]="node.title"
          [attr.tabindex]="flyout && (depth === 0 || node.url) ? 0 : -1"
          >
          {{ node.title }}
          @if (flyout && node.children?.length > 0) {
            <cx-icon
              [type]="iconType.CARET_DOWN"
            ></cx-icon>
          }
        </h5>
      }
      @if (node.content && node.isParagraphComponent) {
        <div class="wrapper footer-paragraph"
          [innerHTML]="node.content"
          [class]="node.styleClasses">
        </div>
      }
    }


    <!-- we add a wrapper to allow for better layout handling in CSS -->
    @if (node.children?.length > 0) {
      <div class="wrapper">
        @if (node.url) {
          <cx-generic-link
            [url]="node.url"
            [target]="node.target"
            class="all"
            >
            {{ 'navigation.shopAll' | cxTranslate: { navNode: node.title } }}
          </cx-generic-link>
        }
        <div
          class="childs"
          [attr.depth]="getTotalDepth(node)"
          [attr.wrap-after]="node.children?.length > wrapAfter ? wrapAfter : null"
          [attr.columns]="getColumnCount(node.children?.length)"
          >
          @for (child of node.children; track child) {
            <ng-container
              *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }"
              >
            </ng-container>
          }
          <!-- <ng-container *ngIf="index === count - 1">
          <button #open class="consent" (click)="openDialog()">
            {{ 'anonymousConsents.preferences' | cxTranslate }}
          </button>
        </ng-container> -->
      </div>
    </div>
  }
</nav>

</ng-template>